export default {
  'logger': false,
  'consolelog': true,
  'API_URL': 'https://bf-backend.azurewebsites.net/',
  'WIJMO_LICENSE_KEY': '',
  'MANUAL_PDF_URL': `/manual/manual.pdf`,
};
